angular.module('gym.calendar').factory('Trainers', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('calendar').all('trainers');
}]);
